<template>
  <div>
    <br />
    <div align="center">
      <img class="imgHeight" src="../assets/images/logoa.png" />
    </div>
    <br />
    <div align="">
      <div class="Flex_Table tblEntryForm">
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <fieldset class="EntryBlock">
              <legend style="background-color: transparent !important">
                <div class="Flex_Table tblEntryForm">
                  <div
                    class="Flex_Row"
                    style="margin-left: -5px; margin-bottom: -2px"
                  >
                    <div class="Flex_Cell_Inline" v-if="userTypeID != 3">
                      <span
                        :class="selectTab1 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="GetApplyOrApplied1(1)"
                        >ALL PROGRAMMES</span
                      >
                    </div>
                    <div class="Flex_Cell_Inline">
                      <span
                        :class="selectTab2 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="GetApplyOrApplied1(2)"
                        >APPLIED PROGRAMMES</span
                      >
                    </div>
                  </div>
                </div>
              </legend>
              <div class="Flex_Table tblEntryForm">
                <div
                  class="Flex_Row"
                  valign="bottom"
                  align="left"
                  style="margin-left: 30px"
                >
                  <div class="Flex_Cell" style="width: 10%">
                    <SearchDropDown
                      v-bind:list-data="finYear_list"
                      value-field="finYearID"
                      text-field="finYearName"
                      v-model="finYearID"
                      title="SELECT YEAR"
                      style="padding: 2px"
                      @change="GetApplyOrApplied()"
                    ></SearchDropDown>
                  </div>
                  <div class="Flex_Cell" style="width: 10%">
                    <SearchDropDown
                      v-bind:list-data="finMonth_list"
                      value-field="finMonthID"
                      text-field="finMonthName"
                      v-model="finMonthID"
                      title="SELECT MONTH"
                      style="padding: 2px"
                      @change="GetApplyOrApplied()"
                    ></SearchDropDown>
                  </div>
                  <div class="Flex_Cell" style="width: 20%">
                    <SearchDropDown
                      v-bind:list-data="area_list"
                      value-field="areaID"
                      text-field="areaName"
                      v-model="areaID"
                      first-item="Area"
                      title="SELECT AREA"
                      style="padding: 2px"
                      @change="GetApplyOrApplied()"
                    ></SearchDropDown>
                  </div>
                  <div class="Flex_Cell" style="width: 20%">
                    <AcceptInput
                      :isRequired="true"
                      placeholder="Programme Name, Code"
                      v-model="programmeName"
                      maxlength="50"
                      regExp="([a-zA-Z0-9\(\)\[\]\.\{\}\-\/ ])*"
                      title="ENTER PROGRAMME NAME, CODE"
                      style="padding: 4px"
                    />
                  </div>
                  <div class="Flex_Cell" style="width: 20%">
                    <input
                      type="button"
                      id="btnSearch"
                      name="btnSearch"
                      btnName="btnSearch"
                      value="Search"
                      style="padding: 5px 20px; margin-left: 5px"
                      title="Click here to Search"
                      v-on:click="GetApplyOrApplied()"
                    /><input
                      type="button"
                      id="btnClear"
                      name="btnClear"
                      btnName="btnClear"
                      value="Clear"
                      style="padding: 5px 20px; margin-left: 5px"
                      title="Click here to Clear Filters"
                      @click="clear()"
                    />
                  </div>
                </div>
                <div class="Felx_Row" v-if="selectTab2">
                  <div class="Flex_Cell">
                    <applied-prag
                      ref="tab1"
                      :ProgList="prog_list2"
                      :UserTypeID="userTypeID"
                      :FinYearID="finYearID"
                      style="border: none"
                    ></applied-prag>
                  </div>
                </div>
                <div class="Felx_Row" v-if="selectTab1 && userTypeID != 3">
                  <div class="Flex_Cell">
                    <all-prag
                      ref="tab1"
                      :ProgList="prog_list1"
                      :UserTypeID="userTypeID"
                      :FinYearID="finYearID"
                      style="border: none"
                    ></all-prag>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import axios from "axios";
import config from "@/router/globalConfig";
import HomeJS from "./serviceJS/homeJS.js";
import SearchDropDown from "./ekkControls/SearchDropDown.vue";
import AcceptInput from "./ekkControls/AcceptInput.vue";
import Tab from "./ekkControls/Tab.vue";
import AllProgramme from "./AllProgramme.vue";
import AppliedProgramme from "./AppliedProgramme.vue";

export default {
  name: "Home",
  components: {
    SearchDropDown: SearchDropDown,
    AcceptInput: AcceptInput,
    "all-prag": AllProgramme,
    "applied-prag": AppliedProgramme,
    Tab: Tab,
  },
  data() {
    return {
      userTypeID: -1,
      selectTab1: false,
      selectTab2: true,
      prog_list1: [],
      prog_list2: [],
      finMonth_list: [],
      finMonthID: -1,
      finYear_list: [],
      finYearID: -1,
      area_list: [],
      areaID: -1,
      programmeName: "",
      isApplied: false,
      btnApplyOrApplied: "",
      btnApplyOrAppliedMsg: "",
    };
  },
  methods: {
    clear() {
      this.finYearID = this.finYear_list.filter((item) => {
        return item.isCurrent == true;
      })[0].finYearID;
      this.finMonthID = this.finMonth_list.filter((item) => {
        return item.isCurrent == true;
      })[0].finMonthID;
      this.areaID = -1;
      this.programmeName = "";
      this.GetApplyOrApplied();
    },
    tabClick(type) {
      if (type == 1) {
        this.selectTab1 = true;
        this.selectTab2 = false;
      }
      if (type == 2) {
        this.selectTab1 = false;
        this.selectTab2 = true;
      }
    },
    GetApplyOrApplied() {
      if (this.selectTab1) {
        this.GetProgrammeCalendar(1);
      } else {
        this.GetProgrammeCalendar(2);
      }
    },
    GetApplyOrApplied1(type) {
      // if (this.btnApplyOrApplied == "APPLIED PROGRAMMES") {
      this.GetProgrammeCalendar(type);
      // }
    },
    GetProgFinYear() {
      const _data_ = { finYearID: -1 };
      HomeJS.GetProgFinYear(_data_).then(
        (response) => {
          if (response.data) {
            this.finYear_list = response.data;
            this.GetProgFinMonth();
          }
        },
        (error) => {}
      );
    },
    GetProgFinMonth() {
      HomeJS.GetProgFinMonth().then(
        (response) => {
          if (response.data) {
            this.finMonth_list = response.data;
            this.finMonthID = this.finMonth_list.filter((item) => {
              return item.isCurrent == true;
            })[0].finMonthID;
            this.GetProgAreaList();
          }
        },
        (error) => {}
      );
    },
    GetProgAreaList() {
      const _data_ = { areaID: -1, type: 3 };
      HomeJS.GetProgAreaList(_data_).then(
        (response) => {
          if (response.data) {
            this.area_list = response.data;
            this.finYearID = this.finYear_list.filter((item) => {
              return item.isCurrent == true;
            })[0].finYearID;
            this.GetProgrammeCalendar1(2);
          }
        },
        (error) => {}
      );
    },
    fillUserData() {
      HomeJS.GetCurrentUser().then(
        (response) => {
          if (response.data) {
            this.userTypeID = response.data.loginUser.userTypeID;
            this.GetProgFinYear();
          }
        },
        (error) => {}
      );
    },
    GetProgrammeCalendar(type) {
      const ProgData = {
        finYearID: this.finYearID,
        progTypeID: -1,
        areaGrpID: -1,
        areaID: this.areaID,
        progMonth: this.finMonthID,
        searchText: this.programmeName,
        type: type,
      };
      HomeJS.GetProgrammeCalendar(ProgData).then(
        (response) => {
          if (response.data) {
            // console.log(this.userTypeID);
            if (type == 1 && this.userTypeID != 3) {
              this.prog_list1 = response.data;
              this.tabClick(type);
              this.isApplied = false;
            } else {
              this.prog_list2 = response.data;
              this.tabClick(type);
              this.isApplied = true;
            }
          }
        },
        (error) => {}
      );
    },
    GetProgrammeCalendar1(type) {
      const ProgData = {
        finYearID: this.finYearID,
        progTypeID: -1,
        areaGrpID: -1,
        areaID: this.areaID,
        progMonth: this.finMonthID,
        searchText: this.programmeName,
        type: type,
      };
      HomeJS.GetProgrammeCalendar(ProgData).then(
        (response) => {
          if (response.data) {
            // console.log(this.userTypeID);
            if (type == 1 && this.userTypeID != 3) {
              this.prog_list1 = response.data;
              this.tabClick(type);
              this.isApplied = false;
            } else {
              this.prog_list2 = response.data;
              if (this.prog_list2.length > 0) {
                this.tabClick(type);
                this.isApplied = true;
              } else if (this.userTypeID != 3) {
                this.GetProgrammeCalendar1(1);
              } else {
                this.tabClick(2);
                this.isApplied = true;
              }
            }
          }
        },
        (error) => {}
      );
    },
  },
  watch: {},
  mounted() {
    this.fillUserData();
  },
};
</script>
<style scoped>
/* @import url("../assets/css/Login_v1.0.css"); */
.HeadFont {
  font-size: 13pt;
  color: #161f4e;
}
.BodyFont {
  font-size: 11pt;
  color: #1d1d1d;
}
#CoLogoBlock {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
}
#CoLogoBlock {
  border: solid 1px #0830f714;
  background-color: #0830f714;
  border-radius: 5px;
  margin: 20px;
  padding: 0px;
  max-width: 45%;
  min-width: 25%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 10px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 6px;
  border-bottom: solid thin darkgrey;
}
.payinstruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 20px;
  line-height: 20px;
  font-size: inherit;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px;
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px black;
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.docfileImg {
  height: 50px;
  width: 50px;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  width: 450px;
  border: solid 1px;
  border-radius: 4px;
  top: 200px;
  position: absolute;
  min-height: 256px;
  right: 450px;
  background-color: rgba(255, 248, 248, 0.86); /*rgb(223, 223, 223);*/
  box-shadow: 1px 1px 20px 1px White;
  border-radius: 18px 18px 18px 18px;
  z-index: 2;
  color: black !important;
}
.PopUpDetail {
  padding: 3px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 30px;
  border-bottom: solid 1px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.drop_area {
  height: 60px;
  background-color: antiquewhite;
  margin: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  line-height: 60px;
}
.file_drop {
  font-size: small;
}
.preview_content {
  background-color: lightblue;
  border-radius: 3px;
  margin: 3px;
  min-height: 177px;
  width: 99%;
  overflow: auto;
  padding: 8px;
  border-radius: 1px 1px 20px 20px;
}
.file_column {
  align-content: center;
  text-align: center;
  float: left;
  width: 25%;
  position: relative;
  /* border: solid thin;
                border-radius: 8px; */
  margin-left: 10px;
}
.file_row:after {
  content: "";
  display: table;
  clear: both;
}
.del_img {
  border-radius: 15px;
  cursor: pointer;
  padding: 5px 5px 5px 5px;
  background-color: rgb(255, 0, 0);
  color: White;
  font-weight: bold;
  position: absolute;
  right: -12px;
  z-index: 5001;
}
.del_img:hover {
  background-color: #fb0bbf;
}
.preview_div {
  align-content: center;
  text-align: center;
  height: 100px;
  width: 110px;
  margin: 2px;
  cursor: pointer;
  border: solid thin darkgray;
  border-radius: 10px;
  background-color: rgba(133, 236, 236, 0.15);
}
.percent_div {
  color: #f3dbdb;
  font-weight: bold;
  align-content: center;
  text-align: center;
  width: 100%;
}
.file_preview {
  height: 80px;
  width: 80px;
}
.file_name {
  font-size: 11px;
  text-overflow: ellipsis;
  width: calc(80%);
  display: inline-block;
  /* color: #f3dbdb; */
}
.file_count {
  margin-top: 5px;
  margin-left: 5px;
  vertical-align: middle;
  padding: 0px 3px 3px 3px;
  font-size: small;
  font-weight: bold;
  font-family: Tahoma;
  background-color: rgba(255, 255, 255, 0.41);
  color: Black;
  border: 1px dashed #ccc;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.error_upload {
  background-color: red;
}
.profileDiv {
  height: 170px;
  width: 180px;
}
.signatureDiv {
  height: 170px;
  width: 300px;
}
.profileImg {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  box-shadow: 5px -4px 5px #807878;
  border-left: solid thin;
  border-bottom: solid thin;
}
.AppHeader {
  border: solid thin gainsboro;
  border-radius: 5px;
  min-height: 55px;
  font-size: medium;
  font-weight: bold;
}
.paymentLabels {
  color: black;
  font-weight: bold;
  font-size: medium;
  text-align: left;
}
.paymentLabels > .Flex_Row {
  border-bottom: solid thin ghostwhite;
}
fieldset {
  margin-bottom: 4px !important;
}
.childSaveTable {
  width: 98%;
  margin-left: 10px;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.Green {
  background-color: greenyellow;
  display: block;
  font-weight: 600;
}
.appNoClass {
  display: inline-block;
  border: solid thin;
  padding: 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; 
                box-shadow: 1px 1px 4px 2px darkgrey;*/
  margin: 0px !important;
  width: 95%;
}
.appNoClass:hover {
  background-color: darkorange;
}
.hidenShowClass {
  display: inline-block;
  border: solid thin;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; */
  -webkit-box-shadow: 1px 1px 4px 2px darkgrey;
  box-shadow: 1px 1px 4px 2px darkgrey;
  right: 34px;
  position: absolute;
}
.hidenShowClass:hover {
  background-color: darkorange;
}
.myIconButton {
  padding: 0px;
}
.myIconButton a.glyphicons:before {
  font-size: 21px;
  cursor: pointer;
}
.Multibutton {
  padding: 0px;
}
.Multibutton a.glyphicons:before {
  font-size: 18px;
  cursor: pointer;
  margin-top: -2px;
  display: block;
}
.blackColor {
  color: black;
}
.redColor {
  color: red;
}
.DropDownHeigh {
  height: 27px;
  line-height: 22px;
}
.RowHeight {
  min-height: 29px;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divApplication {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
/* .tblEntryForm > .Flex_Row > .Flex_Cell {
            width: 25% !important;
        } */

@media screen and (max-width: 800px) {
  .HeadFont {
    font-size: 13pt;
  }
  .BodyFont {
    font-size: 11pt;
  }
  #CoLogoBlock {
    width: 700px;
  }
  .imgHeight {
    height: 100%;
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 1023px) {
  .HeadFont {
    font-size: 13pt;
    font-weight: 300;
    color: #161f4e;
  }
  .BodyFont {
    font-size: 11pt;
    color: #1d1d1d;
  }
  #CoLogoBlock,
  #dvPwd {
    width: 380px;
  }
}
@media screen and (max-width: 480px) {
  .HeadFont {
    font-size: 12pt;
  }
  .BodyFont {
    font-size: 9pt;
  }
  #CoLogoBlock {
    width: 700px;
    max-width: 85%;
  }
  .imgHeight {
    height: 80px;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue